import { Navbar } from "components/Navbar";
import { Outlet } from "react-router-dom";

export const ForgotPassword = () => {
    return (
        <div>
            <Navbar />
            <Outlet />
        </div>
    );
};
